import mergeDeep from "../../util/mergeDeep.js";
import redirector from "../../util/redirector.js";
import * as domainConstants from "../../constants/DomainConstants";
import { getStore } from "../../store/configureStore";
import showToastr from "../../util/toastr.js";
import aanvragersFormattedForDropdown from "../../selectors/aanvragersFormattedForDropdown";

export default class AanvraagPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	receiveProps(nextProps) {
		if (this.context.props.aanvraag !== nextProps.aanvraag) {
			this.context.setState({
				aanvraag: mergeDeep({}, nextProps.aanvraag),
				listOfAanvragers: aanvragersFormattedForDropdown(nextProps.aanvraag.aanvragers, true)
			});

			if ((!this.context.state.titleSet && nextProps.aanvraag.typeDossier)) {

				const dossierTabSuffix = nextProps.isNewAanvraag ? "/nieuw/" + nextProps.aanvraag.typeDossier : "/" + nextProps.aanvraagId;

				this.context.props.loadLayout(nextProps.aanvraag.naam ? nextProps.aanvraag.naam : "", nextProps.aanvraag.tabTitel, nextProps.isNewAanvraag, dossierTabSuffix, nextProps.aanvraagId, nextProps.aanvraag.initialisatieOK, nextProps.aanvraag.typeDossier, nextProps.infrastructuurId, (nextProps.aanvraag.redenVanStatus != "121450000" && nextProps.aanvraag.redenVanStatus !== 121450000));

				this.context.setState({
					errors: nextProps.errors
				});
			}
		}
	}

	init() {
		const { aanvraagId, typeAanvraagId, simulatieId } = this.context.props;

		if (aanvraagId) {
			this.context.props.loadAanvraag(aanvraagId);
			this.context.props.loadInfrastructurenByDossierId(aanvraagId);
		}

		if (typeAanvraagId) {
			this.context.props.loadEmptyAanvraag(typeAanvraagId);
		}

		if (!typeAanvraagId && !simulatieId && !aanvraagId) {
			this.context.props.loadEmptyRenovatie();
		}

		if (simulatieId) {
			this.context.props.loadAanvraagFromSimulatie(simulatieId);
		}
	}

	onChange(event) {
		const field = event.target.name;
		const aanvraag = this.context.state.aanvraag;
		aanvraag[field] = event.target.value;

		return this.context.setState({
			aanvraag: aanvraag,
			hasUnsavedChanges: true
		});
	}

	onChangeAanvrager(event, i, data) {
		let aanvraag = this.context.state.aanvraag;

		if (data) {	// data is assigned for autocomplete changes
			const field = data.name;
			aanvraag.aanvragers[i][field] = data.value;
		} else {
			//Nodig voor radiobutton replace name naar rdb
			const field = event.target.name.replace(aanvraag.aanvragers[i].accountId, "");
			aanvraag.aanvragers[i][field] = event.target.value;
		}
		if (event.target.name === "juridischeStatuut" && event.target.value !== domainConstants.ANDER_JURIDISH_STATUUT_GUID)
			aanvraag.aanvragers[i].anderJuridischStatuut = "";

		return this.context.setState({
			aanvraag: aanvraag,
			listOfAanvragers: aanvragersFormattedForDropdown(aanvraag.aanvragers, true),
			hasUnsavedChanges: true
		});
	}

	onChangeContactpersoon(event, i, data) {
		let aanvraag = this.context.state.aanvraag;

		const field = event.target.name;

		if (i === 0)
			aanvraag.contactpersoon1[field] = event.target.value;

		if (i === 1)
			aanvraag.contactpersoon2[field] = event.target.value;

		return this.context.setState({
			aanvraag: aanvraag,
			hasUnsavedChanges: true
		});
	}

	onAddAanvrager() {
		this.context.props.getEmptyAanvrager()
			.then(emptyAanvrager => {
				let aanvraag = this.context.state.aanvraag;
				aanvraag.aanvragers.push(emptyAanvrager);
				if (this.context.props.isNewAanvraag) {
					aanvraag.contactpersoon1.aanvragerId = "default";
					aanvraag.contactpersoon2.aanvragerId = "default";
					aanvraag.contactpersoon2.houderRekeningnummerAanvragerId = "default";
				}
				return this.context.setState({
					aanvraag: aanvraag,
					listOfAanvragers: aanvragersFormattedForDropdown(aanvraag.aanvragers, true),
					hasUnsavedChanges: true
				});
			});
	}

	onRemoveAanvrager(event, i) {
		let aanvraag = this.context.state.aanvraag;
		let errors = mergeDeep({}, this.context.state.errors);

		const aanvrager = aanvraag.aanvragers[i];
		aanvraag.aanvragers.splice(i, 1);
		if (aanvraag.aanvragers.length === 1) {
			aanvraag.contactpersoon1.accountId = aanvraag.aanvragers[0].accountId;
			aanvraag.contactpersoon2.accountId = aanvraag.aanvragers[0].accountId;
			aanvraag.houderRekeningnummerAanvragerId = aanvraag.aanvragers[0].accountId;
			aanvraag.verhoudingRolverdelingAanvragers = "";
		} else {
			aanvraag.houderRekeningnummerAanvragerId = "default";
			if (aanvraag.contactpersoon1.accountId == aanvrager.accountId) {
				aanvraag.contactpersoon1.accountId = aanvraag.aanvragers[0].accountId;
			}
			if (aanvraag.contactpersoon2.accountId == aanvrager.accountId) {
				aanvraag.contactpersoon2.accountId = aanvraag.aanvragers[0].accountId;
			}
		}

		let updatedErrors = {};
		if (errors && errors.aanvragers) {
			Object.keys(errors.aanvragers).map(function (key, index) {
				if (key != i) {
					let newKey = key;
					if (key > i)
						newKey -= 1;

					updatedErrors[newKey] = errors.aanvragers[key];
				}
			});
			errors.aanvragers = updatedErrors;
		}
		return this.context.setState({
			aanvraag: aanvraag,
			listOfAanvragers: aanvragersFormattedForDropdown(aanvraag.aanvragers, true),
			hasUnsavedChanges: true,
			errors: errors
		});
	}

	onSave(event) {
		event.preventDefault();

		this.context.props.saveAanvraag(this.context.state.aanvraag)
			.then((notification) => {
				let isSaved = showToastr(notification);
				if (isSaved)
					this.context.setState({ hasUnsavedChanges: false });

				if (notification === domainConstants.SUCCESS && this.context.props.isNewAanvraag) {
					redirector.goTo("/aanvraag/bevestiging");
				}
			});

		this.context.setState({ titleSet: false });
	}

	onAddGemandateerde(event, aanvragerIndex) {
		let aanvraag = this.context.state.aanvraag;
		let aanvrager = aanvraag.aanvragers[aanvragerIndex];

		this.context.props.getEmptyMandataris(aanvrager.accountId)
			.then(emptyMandataris => {
				aanvrager.mandatarissen.push(emptyMandataris);
				return this.context.setState({
					aanvraag: aanvraag,
					hasUnsavedChanges: true
				});
			});
	}

	onRemoveGemandateerde(event, i, aanvragerIndex, errorIndex) {

		if (this.context.state.aanvraag.aanvragers[aanvragerIndex].mandatarissen.length === 1) {
			let aanvraag = this.context.state.aanvraag;
			let aanvrager = aanvraag.aanvragers[aanvragerIndex];
			this.context.props.getEmptyMandataris(aanvrager.accountId)
				.then(emptyMandataris => {
					let aanvraag = this.context.state.aanvraag;
					aanvraag.aanvragers[aanvragerIndex].mandatarissen[i] = emptyMandataris;
					return this.context.setState({
						aanvraag: aanvraag,
						hasUnsavedChanges: true
					});
				});
		} else {
			const newAanvraag = Object.assign({}, this.context.state.aanvraag, this.context.state.aanvraag.aanvragers[aanvragerIndex].mandatarissen.splice(i, 1));

			this.context.setState({
				aanvraag: newAanvraag,
				hasUnsavedChanges: true
			});
		}

		let aanvraag = this.context.state.aanvraag;
		let errors = mergeDeep({}, this.context.state.errors);
		let updatedErrors = {};
		if (errors && errors.aanvragers && errors.aanvragers[aanvragerIndex] && errors.aanvragers[aanvragerIndex].mandatarissen) {
			let errorsMandatarissen = errors.aanvragers[aanvragerIndex].mandatarissen;
			Object.keys(errorsMandatarissen).map(function (key, index) {
				if (key != i) {
					let newKey = key;
					if (key > i)
						newKey -= 1;
					updatedErrors[newKey] = errorsMandatarissen[key];
				}
			});

			errors.aanvragers[aanvragerIndex].mandatarissen = updatedErrors;
		}
		this.context.setState({
			errors: errors
		});
	}

	onChangeGemandateerde(event, i, aanvragerIndex, data) {
		let aanvraag = this.context.state.aanvraag;
		const field = event.target.name;
		aanvraag.aanvragers[aanvragerIndex].mandatarissen[i][field] = event.target.value;
		return this.context.setState({
			aanvraag: aanvraag,
			hasUnsavedChanges: true
		});
	}
}